function humanize(str) {
  return str
    .replace(/_/g, ' ')
    .replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

document.addEventListener('DOMContentLoaded', function() {
  // URL to fetch all countries with their flags, names, and ISO codes
  // Original source: 'https://restcountries.com/v3.1/all'
  // Reason for not using original source
  //   - Receiving intermittent `GET https://restcountries.com/v3.1/all net::ERR_HTTP2_PROTOCOL_ERROR 200 (OK)`
  const apiUrl = window.countriesData;

  fetch(apiUrl)
    .then(response => response.json())
    .then(data => {
      const countrySelect = document.getElementById('country');

      // Sort countries alphabetically by name
      data.sort((a, b) => a.name.common.localeCompare(b.name.common));

      // Separate pinned countries (US and Vietnam) from the rest
      const pinnedCountries = data.filter(country => country.cca2 === 'US' || country.cca2 === 'VN');
      const otherCountries = data.filter(country => country.cca2 !== 'US' && country.cca2 !== 'VN');

      // Sort pinned countries: US first, then VN
      pinnedCountries.sort((a, b) => {
        if (a.cca2 === 'US') return -1;
        if (b.cca2 === 'US') return 1;
        return 0;
      });

      // Combine pinned countries first, then other countries
      const sortedCountries = [...pinnedCountries, ...otherCountries];

      // Populate the dropdown with each country's name, ISO code, and flag
      sortedCountries.forEach(country => {
        const option = document.createElement('option');
        option.value = country.cca2; // ISO 3166-1 alpha-2 country code
        option.textContent = `${country.flag} ${country.name.common}`; // Flag and country name
        countrySelect.appendChild(option);
      });

      // Initialize Select2 for the country dropdown to enable search
      $('#country').select2({
        placeholder: "Select a country",
        allowClear: true,
        dropdownCssClass: 'v02r-warranty-form--country-dropdown',
        width: '100%'
      });
    })
    .catch(error => console.error('Error fetching countries:', error));

  /* COMMENTED OUT: Phone input initialization - no longer needed
  // Initialize Intl-Tel-Input with country selection and validation
  const phoneInput = document.querySelector("#phone");
  const errorPhone = document.querySelector("#error-phone");
  const phoneNumberFull = document.querySelector("#phone-number-full");

  const iti = window.intlTelInput(phoneInput, {
    initialCountry: "auto",
    geoIpLookup: function(callback) {
      fetch('https://ipinfo.io/json?token=a5fbce6372f0e1')
        .then(response => response.json())
        .then(data => callback(data.country))
        .catch(() => callback("US")); // Default to "US" if geo IP lookup fails
    },
    preferredCountries: ["us", "vn"],
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js", // to enable validation/formatting
  });

  // Handle phone number validation
  phoneInput.addEventListener("input", function() {
    if (phoneInput.value.trim()) {
      if (iti.isValidNumber()) {
        errorPhone.style.display = "none";
        phoneNumberFull.value = iti.getNumber(); // Get the full international format number
      } else {
        errorPhone.textContent = "Invalid phone number. Please check the number and country code.";
        errorPhone.style.display = "block";
      }
    }
  });
  */

  // Handle form submission
  document.getElementById("warranty-form").addEventListener("submit", async function(event) {
    event.preventDefault();

    // Get selected country
    const countrySelect = document.getElementById("country");
    const selectedCountry = countrySelect.value;

    // Validate country selection
    if (!selectedCountry) {
      const errorCountry = document.getElementById("error-country");
      errorCountry.textContent = "Please select a country";
      errorCountry.style.display = "block";
      return;
    }

    // Clear error messages
    document.querySelectorAll(".error-message-block").forEach(el => el.style.display = 'none');

    // Redirect based on country - open in new tab
    const otherCountriesFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSdJpG3GG3C-YYqKUkjVbxjBmwtwU0ig7p3Ho5Ls_hErfRdtTw/viewform";
    const vietnamFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLScH4KkgFVIlrybnyFMl3UoOzIior1pfp--Rcdx44xpNMcpQhQ/viewform";

    if (selectedCountry === "VN") {
      window.open(vietnamFormUrl, '_blank');
    } else {
      window.open(otherCountriesFormUrl, '_blank');
    }

    /* COMMENTED OUT: Original API submission logic
    if (!iti.isValidNumber()) {
      event.preventDefault();
      errorPhone.textContent = "Invalid phone number. Please check the number and country code.";
      errorPhone.style.display = "block";
      return;
    } else {
      phoneNumberFull.value = iti.getNumber(); // Set full international number before submission
      errorPhone.style.display = "none";
    }


    // Clear previous error messages
    document.querySelectorAll(".error-message-block").forEach(el => el.style.display = 'none');

    // Show the loader and disable the button
    const submitButton = document.getElementById("submit-button");
    const loader = document.getElementById("loader");
    const buttonText = document.getElementById("button-text");
    
    // Show the loader
    submitButton.disabled = true;
    loader.style.display = "inline-block";
    buttonText.style.display = "none"; // Hide the button text

    // Gather form data
    const formData = new FormData(event.target);
    const data = {
      recipient: {
        email: formData.get("email"),
        short_code: formData.get("product"),
        country: formData.get("country"),
        name: `${formData.get("first_name")} ${formData.get("last_name")}`,
        phone: iti.getNumber()
      }
    };

    try {
      const response = await fetch("https://api.halio-sonic.com/v1/contacts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      
      const result = await response.json();
      if (result.success) {
        document.getElementById("warranty-form").style.display = 'none';
        const successMessage = document.getElementById("success-message");
        successMessage.style.display = 'flex';
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        displayErrors(result.errors);
      }
    } catch (error) {
      alert("An error occurred. Please try again later.");
      console.error("Form submission error:", error);
    } finally {
      // Reset the button to its original state
      submitButton.disabled = false;
      loader.style.display = "none";
      buttonText.style.display = "inline"; // Show the button text again
    }
    */
  });

  /* COMMENTED OUT: Display errors function - no longer needed
  // Display errors
  function displayErrors(errors) {
    for (const field in errors) {
      const errorMessage = errors[field].join(", ");
      const errorElement = document.getElementById(`error-${field}`);
      if (errorElement) {
        errorElement.textContent = `${field === 'short_code' ? 'Product' : capitalize(field)} ${errorMessage}`;
        errorElement.style.display = 'block';
      }
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  */
});

/* COMMENTED OUT: Product select2 initialization - no longer needed
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Select2 with custom template for dropdown items and selected item
  $('#product').select2({
    placeholder: "Select a product",
    allowClear: true,
    templateResult: formatProductOption, // Custom format for dropdown items
    templateSelection: formatProductSelection, // Custom format for selected item
    dropdownCssClass: 'v02r-warranty-form--product-dropdown',
  });

  // Function to format dropdown items with image preview
  function formatProductOption(product) {
    if (!product.id) {
      return product.text;
    }

    // Get the image URL from the data-img attribute of the option element
    const imageUrl =  $(product.element).data('img');
    const $product = $(`
      <div class="product-option">
        <div class="image-wrapper">
          <img src="${imageUrl}" class="product-image" alt="${product.text}" />
        </div>
        <div class="text">${product.text}</div>
      </div>
    `);

    return $product;
  }

  // Function to format the selected item with image preview
  function formatProductSelection(product) {
    if (!product.id) {
      return product.text;
    }

    const imageUrl = $(product.element).data('img');
    // return $(`<span><img src="${imageUrl}" class="product-image-selected" alt="${product.text}" /> ${product.text}</span>`);
    return $(`
      <div class="product-selected">
        <div class="image-wrapper">
          <img src="${imageUrl}" class="product-image" alt="${product.text}" />
        </div>
        <div class="text">${product.text}</div>
      </div>
    `);
  }
});
*/